import React from 'react';
import Connection from './Icon/Connection';
import Help from './Icon/Help';
import Overview from './Icon/Overview';
import Notification from './Icon/Notification';
import Password from './Icon/Password';
import MySmartMeter from './Icon/MySmartMeter';
import DeleteAccount from './Icon/DeleteAccount';
import Profile from './Icon/Profile';
import Solar from './Icon/Solar';
import PropTypes from 'prop-types';

const Icon = ({ icon, colour, ...props }) => {
  switch (icon) {
    case 'connection':
      return <Connection colour={colour} {...props} />;
    case 'help':
      return <Help colour={colour} {...props} />;
    case 'notification':
      return <Notification colour={colour} {...props} />;
    case 'overview':
      return <Overview colour={colour} {...props} />;
    case 'profile':
      return <Profile colour={colour} {...props} />;
    case 'password':
      return <Password colour={colour} {...props} />;
    case 'smart-meter':
      return <MySmartMeter colour={colour} {...props} />;
    case 'delete-account':
      return <DeleteAccount colour={colour} {...props} />;
    case 'solar':
      return <Solar colour={colour} {...props} />;
    default:
      return;
  }
};

Icon.propTypes = {
  icon: PropTypes.string,
  colour: PropTypes.string,
};

export default Icon;
